import { useMemo } from 'react';

import { useStores } from '../../../stores/useStores';
import type { BingoWidgetDataType, WidgetEntry } from '../types';

export function useBingoWidgets() {
  const { bingoStore } = useStores();

  const {
    currentEventStatus,
    closestBingoEvent,
    bingoResultToShow,
    nextUpcomingBingoEvent,
    currentBingoEvent,
    isLiveBingo,
    upcomingEvents,
    bingoEnabled,
  } = bingoStore;

  const bingoWidgets: BingoWidgetDataType[] = useMemo(() => {
    if (!bingoEnabled) {
      return [];
    }
    const { totalUserReward } = bingoResultToShow || {};
    const hasReward = bingoResultToShow ? Boolean(totalUserReward) : false;
    if (hasReward && bingoResultToShow) {
      return [
        {
          key: 'bingo',
          widgetType: 'reward',
          event: bingoResultToShow,
        },
      ];
    }
    const eventToDisplay = currentEventStatus === 'closed' ? nextUpcomingBingoEvent : closestBingoEvent;
    if (!eventToDisplay) {
      return [];
    }
    if (currentBingoEvent && isLiveBingo) {
      return [
        {
          key: 'bingo',
          widgetType: 'live',
          event: currentBingoEvent,
        },
      ];
    }
    if (!!currentBingoEvent && bingoStore.isEventAboutToStart(currentBingoEvent)) {
      return [
        {
          key: 'bingo',
          widgetType: 'startingSoon',
          event: currentBingoEvent,
        },
      ];
    }
    if (upcomingEvents && upcomingEvents.length) {
      return [
        {
          key: 'bingo',
          widgetType: 'upcoming',
          event: {
            upcomingEvents,
          },
        },
      ];
    }
    return [];
  }, [
    bingoEnabled,
    bingoResultToShow,
    bingoStore,
    closestBingoEvent,
    currentBingoEvent,
    currentEventStatus,
    isLiveBingo,
    nextUpcomingBingoEvent,
    upcomingEvents,
  ]);

  return useMemo(
    () => bingoWidgets.map((data): WidgetEntry<'bingo'> => ({ data, type: 'bingo', id: data.key })),
    [bingoWidgets],
  );
}
